import { useState } from "react";
import { Label } from "../../label";
import { Input } from "../../input";
import { DashboardCard } from "../../dashboard-card";

export interface FormTemplateSelectionContentProps {
  onFormSelect?: (formTitle: string) => void;
}

export function FormTemplateSelectionContent({ onFormSelect }: FormTemplateSelectionContentProps) {
  const [searchTerm, setSearchTerm] = useState("");

  const mockFormTemplates = [
    {
      id: "1",
      title: "Patient Intake Form",
      questions: "12",
      description: "Standard patient information collection",
    },
    {
      id: "2",
      title: "Health Assessment Questionnaire",
      questions: "18",
      description: "Comprehensive health evaluation",
    },
    {
      id: "3",
      title: "Medical History Survey",
      questions: "25",
      description: "Detailed medical background form",
    },
    {
      id: "4",
      title: "Symptom Tracker Form",
      questions: "8",
      description: "Daily symptom monitoring",
    },
    {
      id: "5",
      title: "Treatment Consent Form",
      questions: "6",
      description: "Treatment authorization and consent",
    },
  ];

  const filteredTemplates = mockFormTemplates.filter(
    (template) =>
      template.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      template.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleFormSelect = (formTitle: string) => {
    onFormSelect?.(formTitle);
  };

  return (
    <div className="flex flex-col gap-4 h-full">
      <div className="space-y-2">
        <Label htmlFor="search" className="text-sm font-medium">
          Search Forms
        </Label>
        <Input
          id="search"
          placeholder="Search form templates..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="flex flex-col gap-4 overflow-auto p-1">
        {filteredTemplates.map((template) => (
          <div key={template.id} onClick={() => handleFormSelect(template.title)} className="cursor-pointer">
            <DashboardCard
              statusLabel=""
              title={template.title}
              subtitle=""
              subtitleSecondary=""
              assignees={[]}
              description={`${template.questions} questions`}
              dueDate=""
              priority=""
              timestamp={undefined}
              showUnreadDot={false}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
